<template>
  <div>    
    <div class="columns">
      <div class="column is-4" v-if="!users">
       <p class="subtitle">Users</p>
       <p class="title" v-if="isUsersLoading">Loading users...</p>
        <!-- <p v-if="!isUsersLoading && !users">Please select a category to view its users.</p> -->
      </div>
     
      <div class="column   users-container" v-if="users">
        <div class="columns ">
          <div class="column is-2">
            <p class="subtitle" v-if="users">Agents <strong>({{users.length}}) </strong></p>
          </div>
          <div class="column is-7">
            <b-field expanded>
              <b-input v-model="searchName"  type="search" icon="search" :disabled="!users || !users.length" placeholder="Search Users "></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <a class="button is-primary full-width-button" @click="openModal" >
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
              <span>Add</span>
            </a>
          </div>
        </div>
         
<!--         <div class="columns is-multiline"> -->
         <p class="title" v-if="isUsersLoading">Loading users...</p>  
  <!-- <div v-if="users.length"> -->
  <table class="table is-fullwidth is-responsive" :data="user"  >
  <thead>
    <tr>
       <th>#</th>
       <th>Profile Image</th>
      <th>Agency Code</th>
      <th>Agency Name</th>
      <th>Owner</th>
      <th>Mobile </th>
      <th>GST</th>
      <th>Area</th>
      <th>status</th>
      <th>View</th>
      
    </tr>
  </thead>
 
  <tbody >
    <tr  v-if="!isUsersLoading && users" v-for="(user, index) in filterBy(users, searchName)" :key="user.docId" >
          <td>{{index + 1}}</td>
           <td>
                    <a :href="user.profileImage" target="_blank">
                      <img :src="user.profileImage" :alt="user.name" class="image is-48x48" style="border-radius: 80%;" >
                    </a>
                  </td>
          <td data-label="Agency Code1"><strong> {{user.code}} </strong> </td>
          
          <td>{{user.name}}</td>
          <td>{{user.owner}}</td>
          <td>{{user.mobile}}</td>
          <td>{{user.gst}}</td>
          <td>{{user.area}}</td>
          <td>
          <span class="tag is-success" v-if="user.active == true">Active</span>
          <span class="tag is-danger" v-else>Inactive</span>
          </td>
          <td>
          <i class="fa fa-eye icon" @click="openModal(user)" title="Edit user" ></i>
          </td>
     </tr>

    </tbody> 
    </table> 

    
            
   <!--  </div> -->
    <!-- </div> -->
        

      </div>
    </div>
  </div>
</template>

<script>
import AddUser from './AddUser';
import UsersService from './service';
import UploadService from '../../lib/UploadService';

export default {
  name: 'users',

  created() {
    this.fetchUsers();

    this.$bus.$on('QURY_UPDATE', (updatedUser, isNewUser) => {
      if (isNewUser) {
        this.users.unshift(updatedUser);
      } else {
        this.users = this.users.map(user => {
          if (user.docId === updatedUser.docId) {
            return updatedUser;
          }

          return user;
        });
      }
    });
  },

  components: {
    AddUser
  },

  data() {
   const data = [this.users]
    return {
      isUsersLoading: false,
      searchName: null,
      isAddUpdateUserModalOpen: false,
      files: null,
      isLoading: true,
      users: [],
      status,
       
       isBordered: true,
       isStriped: true,
       isNarrowed: false,
       isHoverable: true,
       isFocusable: false,
       hasMobileCards: true,
       isPaginated: true,
       isPaginationSimple: false,
       defaultSortDirection: 'asc',
       currentPage: 1,
       perPage: 5
    };
  },

  methods: {

    fetchUsers() {
      this.isUsersLoading = true;
      this.users = null;
      UsersService.all().then(users => {
        this.users = users;
        this.isUsersLoading = false;

      });
    },

    deleteUser(userToDelete) {
      this.isUsersLoading = true;
    this.$dialog.confirm({
    message: 'Sure to delete user?',
        onConfirm: () => {
      UsersService.deleteUser(userToDelete.docId).then(() => {
        this.users = this.users.filter(
          user => userToDelete.docId !== user.docId
        );
        this.isUsersLoading = false;
        this.$toast.open('User deleted successfully');
      });
        }
});
    },

    openModal(user = null) {
      this.$modal.open({
        parent: this,
        props: {
          propUser: user,
         // category: this.currentSelectedCategory
        },
        component: AddUser,
        hasModalCard: true
      });
    },

    uploadImage(user) {
      UploadService(this.files[0], 'users', user.docId)
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    }
  }
};
</script>

<style scoped>
.categories-container {
  padding: 0.5rem;
}
.users-container {
  height: 80vh !important;
  overflow-y: scroll;
}
.user-image {
  height: 50px;
  margin-left: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 50%;
 
}



</style>



// WEBPACK FOOTER //
// src/pages/users/Users.vue